<template>
  <div class="heartbeat">
    <!-- 心跳检测弹窗 -->
    <mu-dialog :open.sync="isHeartBeat" max-width="300px" :overlay-close="false" :append-body="false" :overlay="false">
      <p class="dl-title" slot="title">温馨提示</p>
      <div class="dl-content mb20">
        <p>{{ msge }}</p>
      </div>
      <div class="dl-footer" :class="Object.keys(button).length === 2 ? '' : 'dl-f-center'">
        <mu-button v-if="button.user_logout" v-loading="logOffLoading" :color="Object.keys(button).length === 2 ? '#EEEEEE' : themeConfig.dark" :text-color="Object.keys(button).length === 2 ? themeConfig.dark : '#fff'" @click="logOff">{{ button.user_logout }}</mu-button>
        <mu-button v-if="button.user_back" :color="Object.keys(button).length === 2 ? '#EEEEEE' : themeConfig.dark" :text-color="Object.keys(button).length === 2 ? themeConfig.dark : '#fff'" @click="isHeartBeat = false">{{ button.user_back }}</mu-button>
        <mu-button v-if="button.name_fcm" :color="themeConfig.dark" text-color="#fff" @click="goRealName">{{ button.name_fcm }}</mu-button>
      </div>
    </mu-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import md5 from 'js-md5'
import qs from 'qs'
import { logout } from '@/api/login'
import { newPromise, removeToken, removeSession } from '@/utils'
import Cookies from 'js-cookie'
import { isIOS } from '@/utils/validate'

export default {
  name: 'heartbeat',
  props: {
    hasHeartbeat: {
      type: Boolean,
      default: false
    },
    rechargeObj: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    hasHeartbeat (val) {
      if (val) {
        this.isHeart = true
        this.getHeart()
        this.$emit('update:hasHeartbeat', false)
      }
    },
    rechargeObj (val) {
      if (val && val.show === 1) {
        this.isHeartBeat = true
        this.button = val.button
        this.msge = val.msge
      }
    }
  },
  computed: {
    ...mapGetters([
      'init',
      'status',
      'idfa',
      'themeConfig'
    ])
  },
  methods: {
    createHToken () {
      const gameId = this.init.identity
      const uid = this.status.user_id
      const imei = this.idfa
      const random = JSON.stringify(Math.random(0, 9) * 10000).substr(0, 4)
      this.sTime = this.hTime = parseInt(new Date().getTime() / 1000)
      this.hToken = md5('' + gameId + uid + imei + random + this.sTime)
      this.isFirst = true
    },
    getSign () {
      const appKey = `iwj9mcncoob6fr27#${this.init.identity}#249p2yd4qimgm5cm`
      this.signTime = parseInt(new Date().getTime() / 1000)
      this.sign = md5(appKey + this.signTime)
    },
    getHeart () {
      const gameId = this.init.identity
      const uid = this.status.user_id
      if (Cookies.get(`htoken_${gameId}_${uid}`)) {
        this.hToken = Cookies.get(`htoken_${gameId}_${uid}`).split('_')[0]
        this.sTime = Cookies.get(`htoken_${gameId}_${uid}`).split('_')[1]
        this.hTime = parseInt(new Date().getTime() / 1000)
      } else {
        this.createHToken()
      }
      Cookies.set(`htoken_${gameId}_${uid}`, `${this.hToken}_${this.sTime}`, { expires: new Date(new Date().getTime() + 5 * 60 * 1000) })
      this.getSign()
      const obj = {
        hToken: this.hToken,
        sTime: this.sTime,
        hTime: this.hTime,
        hSec: this.init.heartbeat_interval,
        appid: this.init.identity,
        os: window.mobileInfo.os,
        devicebrand: window.mobileInfo.phone, //  待确认
        model: window.mobileInfo.model,
        uuid: this.idfa, //  待确认
        user_id: this.status.user_id,
        user_name: this.status.user_name,
        agent_id: this.$route.query.agent_id || 100000,
        placeid: this.$route.query.placeid || 100000,
        sign: this.sign,
        time: this.signTime,
        idfan: this.$route.query.idfan || ''
      }
      if (isIOS()) {
        obj.idfaiv = this.$route.query.idfv || ''
      }
      this.isFirst = false
      let url = '//log.tanwan.com/wap/heart'
      if (this.init.ui_type === 6) {
        url = '//log.xitwxi.com/wap/heart'
      }
      axios.post(url, qs.stringify(obj), { withCredentials: true }).then(res => {
        if (res.data.ret === 1) {
          // 弹窗
          if (res.data.playero === 'dialog') {
            this.isHeartBeat = true
            this.msge = res.data.data_tips.msge
            this.button = res.data.data_tips.button
          }
          if (res.data.playero === 'user_logout') {
            this.logOff()
          }
          if (res.data.playero === 'game_role_logout') {
            this.$emit('heartbeatFunc', 'closeGame')
          }
          if (res.data.user_for === 1) {
            this.isHeart = false
          }
        }
      }).catch(() => {}).finally(() => {
        setTimeout(() => {
          this.isHeart && this.getHeart()
        }, 60000)
      })
    },
    // 跳转立即实名
    goRealName () {
      this.$emit('heartbeatFunc', 'realName')
    },
    // 退出登陆
    async logOff () {
      this.logOffLoading = true
      const res = await newPromise(logout)
      this.logOffLoading = false
      if (!res.error_code) {
        const gameId = this.init.identity
        const uid = this.status.user_id
        Cookies.remove(`htoken_${gameId}_${uid}`)
        removeToken()
        removeSession()
        try {
          sessionStorage.setItem('username', this.status.user_name)
        } catch (e) {}
        location.reload()
      }
    },
    // 关闭窗口
    closeIsHeartBeat () {
      this.isHeartBeat = false
    }
  },
  data () {
    return {
      isHeartBeat: false,
      hToken: '',
      sTime: null,
      hTime: null,
      msge: '',
      sign: '',
      signTime: null,
      button: {},
      isHeart: false,
      logOffLoading: false,
      isFirst: false //  是否第一次请求
    }
  }
}
</script>

<style lang="less" scoped>
.dl-title {
  font-size: 20px;
  color: #333;
  width: 100%;
  font-weight: 600;
  text-align: center;
  position: relative;
  .back-icon {
    font-size: .56rem;
    color: #CCCBCA;
    position: absolute;
    left: 4px;
    top: 3px;
  }
}
.dl-content {
  font-size: .2rem;
  color: #333;
  line-height: .36rem;
  letter-spacing: .06rem;
  .dl-c-title {
    padding-bottom: .2rem;
    font-size: .26rem;
    font-weight: 800;
  }
}
.dl-footer {
  display: flex;
  justify-content: space-between;
}
.dl-f-center {
  justify-content: center;
}
.mb20 {
  margin-bottom: .2rem;
}
.heartbeat {
  /deep/ .mu-dialog-wrapper {
    z-index: 20141200!important;
  }
}
@media screen and (max-width:450px) {
  .dl-title {
    font-size: .36rem;
  }
}
</style>
